import { useMemo } from 'react';
import useSWR, { mutate } from 'swr';

export const endpoints = {
    key: 'snackbar'
};

const initialState = {
    action: false,
    open: false, // Set to true for initial testing
    message: 'Note archived',
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
    },
    variant: 'default',
    alert: {
        color: 'primary',
        variant: 'filled'
    },
    transition: 'Fade',
    close: true,
    actionButton: false,
    maxStack: 3,
    dense: false,
    iconVariant: 'usedefault'
};

export function useGetSnackbar() {
    const { data, error } = useSWR(endpoints.key, initialState, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    if (error) {
        console.error('Error fetching snackbar state:', error);
    }

    const memoizedValue = useMemo(() => ({ snackbar: data || initialState }), [data]);

    return memoizedValue;
}

export function openSnackbar(snackbar) {
    const { action, open, message, anchorOrigin, variant, alert, transition, close, actionButton } = snackbar;
    console.log('Opening snackbar with settings:', snackbar);
    if (snackbar.autoClose) {
        setTimeout(() => {
            closeSnackbar();
        }, snackbar.autoCloseDuration || 5000); // Default duration is 5000 milliseconds (5 seconds)
    }
    mutate(
        endpoints.key,
        (currentSnackbar = initialState) => {
            return {
                ...currentSnackbar,
                action: action !== undefined ? action : initialState.action,
                open: open !== undefined ? open : initialState.open,
                message: message || initialState.message,
                anchorOrigin: anchorOrigin || initialState.anchorOrigin,
                variant: variant || initialState.variant,
                alert: {
                    color: alert?.color || initialState.alert.color,
                    variant: alert?.variant || initialState.alert.variant
                },
                transition: transition || initialState.transition,
                close: close !== undefined ? close : initialState.close,
                actionButton: actionButton !== undefined ? actionButton : initialState.actionButton
            };
        },
        false
    );
}

export function closeSnackbar() {
    console.log('Closing snackbar');
    mutate(
        endpoints.key,
        (currentSnackbar = initialState) => {
            return { ...currentSnackbar, open: false };
        },
        false
    );
}

export function handlerIncrease(maxStack) {
    mutate(
        endpoints.key,
        (currentSnackbar = initialState) => {
            return { ...currentSnackbar, maxStack };
        },
        false
    );
}

export function handlerDense(dense) {
    mutate(
        endpoints.key,
        (currentSnackbar = initialState) => {
            return { ...currentSnackbar, dense };
        },
        false
    );
}

export function handlerIconVariants(iconVariant) {
    mutate(
        endpoints.key,
        (currentSnackbar = initialState) => {
            return { ...currentSnackbar, iconVariant };
        },
        false
    );
}
